export default class LoadingSpinner {
    onCreate(input) {
        if (input) {
            this.spinnerId = input.spinnerId;
            this.ignoreWildcard = input.ignoreWildcard;
            this.state = {
                isShow: this.isShow(input.isShow),
                spinnerStyle: ''
            };
        }
    }
    onInput(input) {
        this.state.isShow = this.isShow(input.isShow);
    }
    isShow(isShow) {
        return !!(isShow && isShow === 'true');
    }
    onMount() {
        if (this.spinnerId) {
            document.addEventListener('str-loading-spinner-toggle-event', evt => {
                if (
                    evt.detail && (
                        evt.detail.id === this.spinnerId ||
                        (!this.ignoreWildcard && evt.detail.id === '*')
                    )
                ) {
                    this.state.isShow = evt.detail.isShow;
                    handleSpecificSpinners.call(this);
                }
            });
        }
    }
}

function handleSpecificSpinners() {
    if (this.spinnerId === 'tab0LoadingSpinner') {
        tab0LoadingSpinner.call(this);
    }
}

// Position the items grid spinner (id = 'tab0LoadingSpinner').
// Since the items grid can be scrolled out of view, we need to
// dynamically set the spinner position.
function tab0LoadingSpinner() {
    const itemGrid = document.querySelector('.str-items-grid');
    const controlBar = document.querySelector('.str-controlbar-wrap');

    if (itemGrid && controlBar) {
        const itemGridTop = itemGrid.getBoundingClientRect().top;
        const controlBarBtm = controlBar.getBoundingClientRect().bottom;
        const pad = 200;
        let spinnerStyle;

        if (itemGridTop > 0 && itemGridTop < controlBarBtm) {
            spinnerStyle = `top: ${ controlBarBtm - itemGridTop + pad }px`;
        } else if (itemGridTop < controlBarBtm) {
            spinnerStyle = `top: ${ Math.abs(itemGridTop) + controlBarBtm + pad }px`;
        } else {
            spinnerStyle = '';
        }

        this.state.spinnerStyle = spinnerStyle;
    }
}
